import { getBackendUrl } from "@Utils";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axiosWrapper from "../services/axiosWrapper";
import type { GetAllDsrItemsResponse, SaveDsrItemResponse } from "@ServerTypes/dsr/dsr.schema";

export const saveDsrItemData = createAsyncThunk("dsr/saveDsrItemData", async (data: any, { rejectWithValue }) => {
  try {
    const responseData = await axiosWrapper.post<SaveDsrItemResponse>(`${getBackendUrl()}/dsr/saveDsrItemData`, data);
    if (responseData.data.status) {
      return (responseData.data as any).data;
    }
    return rejectWithValue(responseData.data);
  } catch (error: any) {
    return rejectWithValue(error?.response?.data || error?.message);
  }
});

export const getDsrItemsData = createAsyncThunk("dsr/getDsrItemsData", async (data: any, { rejectWithValue }) => {
  try {
    const responseData = await axiosWrapper.post<GetAllDsrItemsResponse>(`${getBackendUrl()}/dsr/getAllDsrItems`, data);
    if (responseData.status) {
      return responseData.data;
    }
    return rejectWithValue(responseData.data);
  } catch (error: any) {
    return rejectWithValue(error?.response?.data || error?.message);
  }
});

const dsrItemsSlice = createSlice({
  name: "dsrItems",
  initialState: [],
  reducers: {
    getDsrItems: (_state: any, action: PayloadAction<any>) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(getDsrItemsData.fulfilled, (_state: any, action: PayloadAction<any>) => action.payload);
  },
});

const costDatabaseSlice = createSlice({
  name: "costDatabase",
  initialState: {},
  reducers: {
    setCostDatabase: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setCostDatabase } = costDatabaseSlice.actions;

export const getDsrItems = dsrItemsSlice.reducer;
export const costDatabase = costDatabaseSlice.reducer;
